var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.prevRoutes.length > 1)?_c('div',{staticClass:"car-btn-back",on:{"click":function($event){return _vm.goBack()}}},[_c('div',{staticClass:"car-icon"}),_c('span',{staticClass:"car-text"},[_vm._v(_vm._s(_vm.$t('backBtn')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }